<template>
    <v-container fluid>
        <h1><v-icon>mdi-calendar-remove-outline</v-icon> วันหยุดหวย</h1>

        <v-row justify="center">
            <v-col cols="12" md="4">
                <CreateLottoHolidays
                    :loading="loading"
                    :categories="categories"
                    @createSuccess="onCreateSuccess"
                ></CreateLottoHolidays>
            </v-col>
            <v-col cols="12" md="8">
                <v-card :disabled="loading" :loading="loading" outlined>
                    <v-card-title>วันหยุดหวย</v-card-title>
                    <v-card-subtitle>ระบบจัดการวันหยุดหวย</v-card-subtitle>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-select
                                    :loading="loading"
                                    :items="categories"
                                    :disabled="loading"
                                    item-value="id"
                                    item-text="name"
                                    label="หมวดหมู่หวย"
                                    v-model="category"
                                    @change="selectCategory"
                                ></v-select>
                            </v-col>
                            <v-col>
                                <v-select
                                    :loading="loading"
                                    :disabled="loading"
                                    :items="listYear"
                                    :value="year"
                                    label="เลือกปี"
                                    @change="selectYear"
                                >
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <LottoHolidayList
                    :loading="loading"
                    :lottoName="lottoName"
                    :holidays="holidays"
                    :year="year"
                    @deleteEvent="onDelete"
                    class="mt-5"
                ></LottoHolidayList>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";

import CreateLottoHolidays from "../components/holidays/create";
import LottoHolidayList from "../components/holidays/list";

export default {
    components: {
        CreateLottoHolidays,
        LottoHolidayList,
    },
    data: () => {
        return {
            category: null,
            loading: true,
            year: new Date().getFullYear() + 543,
            load_holiday: false,
        };
    },
    computed: {
        ...mapState("lottoCategory", ["categories"]),
        ...mapGetters("lottoHolidays", ["holidays"]),
        listYear() {
            const thisYear = new Date().getFullYear();
            const years = [];
            for (let i = thisYear - 2; i <= thisYear + 20; i++) {
                const year = i + 543;
                years.push({
                    text: year,
                    value: year,
                });
            }
            return years;
        },
        lottoName() {
            for (const cate of this.categories) {
                if (cate.id === this.category) {
                    return cate.name;
                }
            }
            return "-";
        },
    },
    created() {
        document.title = "วันหยุดหวย";
        this.loadCategories();
    },
    methods: {
        ...mapActions("lottoCategory", ["getCategories"]),
        ...mapActions("lottoHolidays", ["getHolidays"]),
        async loadCategories() {
            this.loading = true;
            try {
                const resp = await this.getCategories();
                if (!resp.success && resp.message) {
                    this.$notify({
                        type: "error",
                        title: "Error",
                        text: resp.message,
                    });
                }
            } catch (err) {
                const errMsg =
                    (err &&
                        err.response &&
                        err.response.data &&
                        err.response.data.message) ||
                    err.message ||
                    "พบปัญหากับระบบกรุณาลองใหม่อีกครั้งภายหลัง";
                this.$notify({
                    type: "error",
                    title: "Error",
                    text: errMsg,
                });
            }
            this.loading = false;
        },

        selectYear(year) {
            this.year = year;
            this.loadHolidays();
        },

        selectCategory(category) {
            this.category = category;
            this.loadHolidays();
        },

        async loadHolidays() {
            if (!this.year || !this.category) return false;
            this.load_holiday = true;
            this.loading = true;
            try {
                const { category, year } = this;
                const data = await this.getHolidays({
                    cate_id: category,
                    year,
                });
                if (data.success) {
                    this.$notify({
                        type: "success",
                        title: "สำเร็จ",
                        text: "โหลดข้อมูลวันหยุดเรียบร้อย",
                    });
                } else if (!data.success && data.message) {
                    this.$notify({
                        type: "error",
                        title: "Error",
                        text: data.message,
                    });
                } else {
                    this.$notify({
                        type: "error",
                        title: "Error",
                        text: "ไม่สามารถโหลดข้อมูลได้กรุณาลองใหม่อีกครั้ง",
                    });
                }
            } catch (err) {
                const errMsg =
                    (err &&
                        err.response &&
                        err.response.data &&
                        err.response.data.message) ||
                    err.message ||
                    "พบปัญหากับระบบกรุณาลองใหม่อีกครั้งภายหลัง";
                this.$notify({
                    type: "error",
                    title: "Error",
                    text: errMsg,
                });
            }
            this.loading = false;
        },

        onCreateSuccess({ cate_id }) {
            this.category = cate_id;
            this.loadHolidays();
        },

        onDelete() {
            this.loadHolidays();
        },
    },
};
</script>
